import { graphql } from "@/api/graphql/types/gql.ts";

export const updateFormDataRuleGroupMutation = graphql(`
  mutation UpdateFormDataRuleGroup(
    $request: MiddleMsUpdateFormDataRuleGroupRequest!
  ) {
    MiddleMsUpdateFormDataRuleGroup(request: $request)
  }
`);
